enum EventNotificationType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  CALL = 'CALL',
  NO_NOTIFICATION = 'NO_NOTIFICATION',
}

export default EventNotificationType;
